import styled from "styled-components";

import { Alert as BaseAlert } from "_/components/alert";
import { AlertContent } from "_/components/alert/styled";
import { Button } from "_/components/button";

export const Alert = styled(BaseAlert)`
  position: absolute;
  bottom: 2.5rem;
  left: 50%;
  transform: translateX(-50%);
  width: max-content;
  padding: 0.125rem 0.5rem 0.125rem 1.25rem;
  /* 
    Custom dark blue (same hue as primary blue) used for
    overlapping other elements where normal Alert transparency
    will not provide enough contrast.
   */
  background-color: rgba(30, 43, 62, 0.9);

  & ${AlertContent} {
    align-items: center;
  }
`;

export const Content = styled.div`
  display: flex;
  gap: 0.75rem;
  align-items: center;
  padding-left: 0.75rem;
`;

export const Actions = styled.div`
  display: flex;
  gap: 0.5rem;
  align-items: center;
`;

export const RefreshButton = styled(Button)`
  color: ${(p) => p.theme.color.palette.cornflowerBlue};
  &:hover:enabled {
    color: ${(p) => p.theme.color.palette.electricBlue};
  }
  &:focus:enabled:not(:focus-visible) {
    outline: none;
  }
`;

export const CloseButton = styled(Button)`
  color: inherit;

  &:hover:enabled {
    color: ${(p) => p.theme.text.hover};
  }
`;
